import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeCircle extends Shape {
    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 2) / 3 - 2 * horizontalPadding;
        const allowedHeight = (height * 2) / 3 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, height / 5, null);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.ellipse(
            x + width / 2,
            y + height / 2,
            height / 2,
            width / 2,
            Math.PI / 2,
            0,
            2 * Math.PI,
        );
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" d="M0 0h24v24H0z"/>
                <path stroke="${stroke}" d="M12 23c6.0751 0 11-4.9249 11-11S18.0751 1 12 1 1 5.9249 1 12s4.9249 11 11 11Z"/>
            </svg>
        `;
    }
}
